import * as React from 'react'

import { Alert, Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { Authorized } from 'modules/core/components/Authorized'
import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import filesStore from 'modules/documents/components/Documents/store'
import FileList from 'modules/documents/components/FileList'
import useUpload from 'modules/documents/hooks/templates/useUpload'

interface Props {
  onClose: () => void
}

const CreateModal = ({ onClose }: Props) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  const { onSubmit, values, setValues, addFiles, loading, onDeleteFile, errors } = useUpload({
    onUploadFinished: async () => {
      onClose()
    },
  })

  const onDropFiles = (files: File[]) => {
    addFiles(files)
  }
  const hasFiles = filesStore.files.length > 0
  const disabled = !hasFiles || !values.name || loading

  useEffect(() => {
    if (loading) {
      app.setProgress({ message: i18n.t('common.saving') })
    } else {
      app.setProgress(null)
    }
  }, [loading])

  return (
    <Modal
      illustration="file-upload"
      title={i18n.t('documents.document_templates.list.create_modal.title')}
      description={i18n.t('documents.document_templates.list.create_modal.description_fillable')}
      onClose={onClose}
      footer={
        <Button disabled={disabled} type="primary" onClick={onSubmit}>
          {i18n.t('documents.document_templates.list.create_modal.submit')}
        </Button>
      }
    >
      <Box flexDirection="column" justifyContent="center" gap="s32">
        <TextField
          label={i18n.t('documents.document_templates.list.create_modal.template_name')}
          value={values.name}
          onChange={(value) => setValues({ ...values, name: value })}
          error={errors.name}
        />
        {!hasFiles && (
          <Authorized subscription={subscription}>
            <DropzoneBox
              onDrop={onDropFiles}
              accept={{
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
                'application/pdf': [],
              }}
              message={i18n.t(
                'documents.document_templates.list.create_modal.dropdown_zone_fillable'
              )}
            />
          </Authorized>
        )}
        {hasFiles && (
          <FileList files={filesStore.files} onDeleteFile={onDeleteFile} spaced={false} />
        )}
      </Box>

      {errors.file && (
        <Box paddingTop="s24">
          <Alert color="error">
            <Box flexNoShrink>
              <Icon.Medium icon="alert-circle" color="grey800" />
            </Box>
            <Text.Normal>{errors.file}</Text.Normal>
          </Alert>
        </Box>
      )}
    </Modal>
  )
}

export default observer(CreateModal)
